import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from './Button';
import { useBrand } from '../../contexts/BrandContext';
interface CtaBandProps {
  title?: string;
  intro?: string;
}
export function CtaBand({
  title,
  intro
}: CtaBandProps) {
  const {
    brand,
    text
  } = useBrand();
  const heading = title ? text(title) : brand.copy.manifesto;
  const body = intro ? text(intro) : brand.copy.ctaIntro;
  return <section className="bg-cream-deep" data-id="element-294" data-mp="v3k1mrxkcn9x">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-20" data-id="element-295" data-mp="v0fqfalokr9r">
        <div className="grid items-center gap-8 lg:grid-cols-[1.2fr_auto] lg:gap-16" data-id="element-296" data-mp="qzm42lnvzkiz">
          <div data-id="element-297" data-mp="m2vmtv0ciivz">
            <h2 className="max-w-2xl font-serif text-3xl font-bold leading-tight text-ink md:text-5xl" data-id="element-298" data-mp="m2cdv3sob4u3">
              {heading}
            </h2>
            <p className="mt-5 max-w-lg text-base leading-relaxed text-ink-soft" data-id="element-299" data-mp="2ggn3vfl0851g">{body}</p>
          </div>
          <div className="flex flex-wrap items-center gap-3" data-id="element-300" data-mp="2bgiipc95im4w">
            <Button to="/get-started" size="lg" data-id="element-301" data-mp="2bf7j7omqo0jl">
              Get started
              <ArrowRightIcon className="h-4 w-4" data-id="element-302" data-mp="2p4ikp8yq29ij" />
            </Button>
            <Button to="/pricing" variant="secondary" size="lg" data-id="element-303" data-mp="2t8q7v1pj7hen">
              See what it costs
            </Button>
          </div>
        </div>
      </div>
    </section>;
}